import tw from 'tailwind-styled-components'

export const TestListCareContainer = tw.div`
    py-10
    relative
`
